module.exports = __webpack_public_path__ + "static/img/marmalade_pictgrid9_800x694.5a2460c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/marmalade_pictgrid9_800x694.jpg
// module id = VI93
// module chunks = 0